module.exports = "<p-button icon=\"fas fa-tasks\" label=\"{{ 'LAYOUT:BUTTON:SHOW_TASKS' | translate }}\" (onClick)=\"showTasks()\"></p-button>\r\n"